import React, { useEffect, useState } from "react";
import Address from "../components/cart/Address";
import Carts from "../components/cart/Checkout";
import req from "../axios/interceptedAxiosInstance";
import AddressInput from "../components/form-input/address-input/AddressInput";
import { handleDisable } from "../utils/btn/handleDisable";
import DeliveryDetail from "../components/cart/DeliveryDetail";
import { errorToast, successToast } from "../notification/notification";
import CartFlexed from "../layouts/cart/CartFlexed";
import EditAddress from "../components/cart/EditAddress";
import Backdrop from "../layouts/Backdrop";
import useAuth from "../hooks/useAuth";
import rolling from "../assets/rolling-white.svg";
import Input from "../components/form-input/Input";
import validator from "validator";

const Checkout = () => {
  const { cart } = useAuth();
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [userAddress, setUserAddress] = useState([]);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [selection, setSelection] = useState("");
  const [loading, setLoading] = useState(false);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [address, setAddress] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [editFirstname, setEditFirstname] = useState("");
  const [editLastname, setEditLastname] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [editPhonenumber, setEditPhonenumber] = useState("");
  const [editAddress, setEditAddress] = useState("");
  const [editState, setEditState] = useState("");
  const [editCity, setEditCity] = useState("");
  const [editedAddressID, setEditedAddressID] = useState("");

  const [deliveryOption, setDeliveryOption] = useState("");
  const [selectedAddress, setSelectedAddress] = useState("");

  const getUserAddress = async () => {
    setLoadingAddress(true);
    try {
      const response = await req.get("address/fetch");
      setUserAddress(response.data.data);
      setLoadingAddress(false);
    } catch (error) {
      console.log(error);
      setLoadingAddress(false);
    }
  };

  const addressOption = (e) => {
    setSelection(e.target.value);
  };

  const reqBody = {
    address: address,
    city: city,
    email: email,
    first_name: firstname,
    last_name: lastname,
    phone_number: phonenumber,
    state: state,
  };

  const disable = handleDisable([
    address,
    city,
    email,
    firstname,
    lastname,
    phonenumber,
    state,
  ]);

  const addAddress = async () => {
    if (validator.isEmail(email) && validator.isMobilePhone(phonenumber)) {
      setLoading(true);
      try {
        const response = await req.post("address/store", reqBody);
        successToast(response?.data?.message);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
      getUserAddress();
    } else {
      errorToast("invalid email or phone number");
    }
  };

  const toggleBackdrop = () => {
    setOpenBackdrop((prev) => !prev);
  };

  const edited = {
    first_name: editFirstname,
    last_name: editLastname,
    email: editEmail,
    phone_number: editPhonenumber,
    address: editAddress,
    state: editState,
    city: editCity,
  };

  const handleEdit = async () => {
    if (
      validator.isEmail(editEmail) &&
      validator.isMobilePhone(editPhonenumber)
    ) {
      setLoading(true);
      try {
        const response = await req.put(
          `address/update/${Number(editedAddressID)}`,
          edited
        );
        getUserAddress();
        successToast(response?.data?.message);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
      toggleBackdrop();
    } else {
      errorToast("invalid email or phone number");
    }
  };

  useEffect(() => {
    getUserAddress();
  }, []);

  return (
    <div className="bg-slate-100 min-h-screen pb-5 md:pb-44">
      <CartFlexed>
        <div>
          <div className="">
            <h3 className="font-bold text-lg md:text-xl mt-3">
              Shipping Address
            </h3>
            {loadingAddress ? (
              <div className="h-addressHeight">
                <img
                  src={rolling}
                  alt="loading"
                  className="w-10 h-full m-auto"
                />
              </div>
            ) : (
              userAddress.map((address) => (
                <Address
                  address={address}
                  key={address.id}
                  setSelection={setSelection}
                  getUserAddress={getUserAddress}
                  toggleBackdrop={toggleBackdrop}
                  setEditFirstname={setEditFirstname}
                  setEditLastname={setEditLastname}
                  setEditEmail={setEditEmail}
                  setEditPhonenumber={setEditPhonenumber}
                  setEditAddress={setEditAddress}
                  setEditCity={setEditCity}
                  setEditState={setEditState}
                  setEditedAddressID={setEditedAddressID}
                  setSelectedAddress={setSelectedAddress}
                  selectedAddress={selectedAddress}
                />
              ))
            )}
            <div
              className={`w-full md:w-[500px] lg:w-[600px] xl:w-addressWidth h-addressHeight bg-white mt-3 p-3 transition-all`}
            >
              <div className="h-full flex items-center gap-4">
                <AddressInput
                  value="Add a new address"
                  onchange={addressOption}
                  name="address"
                />
                <p className="font-bold text-sm">Add a new address</p>
              </div>
            </div>
            {selection === "Add a new address" && (
              <div className="w-full md:w-[500px] lg:w-[600px] xl:w-addressWidth bg-white pr-10 pl-10 pb-5">
                <div className="flex flex-wrap justify-between">
                  <div className="w-full md:w-49.5% h-addressHeight">
                    <Input
                      type="text"
                      placeholder="First Name"
                      value={firstname}
                      onValueChange={setFirstname}
                      required={true}
                    />
                  </div>
                  <div className="w-full md:w-49.5% h-addressHeight">
                    <Input
                      type="text"
                      placeholder="Last Name"
                      value={lastname}
                      onValueChange={setLastname}
                      required={true}
                    />
                  </div>
                  <div className="w-full md:w-49.5% h-addressHeight">
                    <Input
                      type="email"
                      placeholder="Email Address"
                      value={email}
                      onValueChange={setEmail}
                      required={true}
                    />
                  </div>
                  <div className="w-full md:w-49.5% h-addressHeight">
                    <Input
                      type="tel"
                      placeholder="Phone Number"
                      value={phonenumber}
                      onValueChange={setPhonenumber}
                      required={true}
                    />
                  </div>

                  <div className="w-full h-addressHeight border-none">
                    <Input
                      type="text"
                      placeholder="Address"
                      value={address}
                      onValueChange={setAddress}
                      required={true}
                    />
                  </div>

                  <div className="w-full md:w-49.5% h-addressHeight">
                    <Input
                      type="text"
                      placeholder="State/Region"
                      value={state}
                      onValueChange={setState}
                      required={true}
                    />
                  </div>

                  <div className="w-full md:w-49.5% h-addressHeight">
                    <Input
                      type="text"
                      placeholder="City"
                      value={city}
                      onValueChange={setCity}
                      required={true}
                    />
                  </div>
                </div>
                <div className="flex justify-end mt-2">
                  <button
                    className={`w-24 h-10 rounded-3xl font-bold outline-none 
                  ${disable ? "bg-label" : "bg-logoRed"}
                  ${disable ? "text-black" : "text-white"}`}
                    disabled={disable}
                    onClick={addAddress}
                  >
                    {loading ? "Saving..." : "save"}
                  </button>
                </div>
              </div>
            )}
          </div>

          <DeliveryDetail
            details={cart}
            setDeliveryOption={setDeliveryOption}
          />
        </div>

        <div className="">
          <Carts
            carts={cart}
            deliveryOption={deliveryOption}
            selectedAddress={selectedAddress}
          />
        </div>
      </CartFlexed>

      <Backdrop
        openBackdrop={openBackdrop}
        component={
          <EditAddress
            editFirstname={editFirstname}
            setEditFirstname={setEditFirstname}
            editLastname={editLastname}
            setEditLastname={setEditLastname}
            editEmail={editEmail}
            setEditEmail={setEditEmail}
            editPhonenumber={editPhonenumber}
            setEditPhonenumber={setEditPhonenumber}
            editAddress={editAddress}
            setEditAddress={setEditAddress}
            editState={editState}
            setEditState={setEditState}
            editCity={editCity}
            setEditCity={setEditCity}
            toggleBackdrop={toggleBackdrop}
            handleEdit={handleEdit}
            loading={loading}
          />
        }
      />
    </div>
  );
};

export default Checkout;
